type AthenaRankableCoverage = {
  casePolicy: boolean;
  sequence: number | null;
  ehrCancelledAt?: string | null;
};

/** A case-policy package in a primary/secondary slot is not a standalone case policy. */
export function isAthenaStandaloneCasePolicy(policy: Pick<AthenaRankableCoverage, "casePolicy" | "sequence">): boolean {
  return policy.casePolicy && (policy.sequence == null || policy.sequence === 0);
}

export function athenaLeftoverSequencesAreContiguous(sequences: readonly number[]): boolean {
  const sorted = [...sequences].toSorted((left, right) => left - right);
  const first = sorted[0];

  return (
    first == null ||
    (first > 0 && sorted.every((sequence, index) => Number.isInteger(sequence) && sequence === first + index))
  );
}

export function athenaRankedStandardCoverages<T extends AthenaRankableCoverage>(policies: readonly T[]): T[] {
  return policies
    .filter((policy) => !policy.casePolicy && !policy.ehrCancelledAt && policy.sequence != null)
    .toSorted((left, right) => left.sequence! - right.sequence!);
}

export function athenaStandardCoverageRank(
  policies: readonly AthenaRankableCoverage[],
  target: Pick<AthenaRankableCoverage, "sequence">
): number | null {
  const index = athenaRankedStandardCoverages(policies).findIndex((policy) => policy.sequence === target.sequence);

  return index === -1 ? null : index + 1;
}
